module.exports = __webpack_public_path__ + "img/sample-aeronautical.12bbdbd7.webp";